import { render, staticRenderFns } from "./quizCoin.vue?vue&type=template&id=47e58468&scoped=true&"
import script from "./quizCoin.vue?vue&type=script&lang=js&"
export * from "./quizCoin.vue?vue&type=script&lang=js&"
import style0 from "./quizCoin.vue?vue&type=style&index=0&id=47e58468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e58468",
  null
  
)

export default component.exports